import React, { useState, useEffect, useCallback } from 'react';
import { attendanceActions } from './actions';
import './StatisticsGroups.css'; 


const month_ukr = [
  'січень', 'лютий', 'березень', 'квітень', 'травень', 'червень', 
  'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень'
];

const day_ua = [
  { t: 'нд', col: 'red' },
  { t: 'пн' },
  { t: 'вт' },
  { t: 'ср' },
  { t: 'чт' },
  { t: 'пт' },
  { t: 'сб', col: 'red' }
];

const status_tabel = {
  'current': 'Не закритий',
  'closed': 'Закритий',
  'need_approve': 'Потребує затвердження'
};

const StatisticaAttendanceGroup = (props) => {
  const { kgId, kgGroup, group,  groups, isArchive } = props;

  console.log({ function: 'StatisticaAttendanceGroup', isArchive: isArchive ? 'Yes': 'No'});
  
  const [infoInvites, setInfoInvites] = useState({
    group: { gr_number: kgGroup },
    tabel: []
  });
  const [period, setPeriod] = useState('');
  const [optPeriodSt, setOptPeriodSt] = useState([]);
  const [dataListChildren, setDataListChildren] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Генерация периодов для выбора
  const optionsPeriodStatistic = useCallback(() => {
    const MAX_LENGTH_PERIOD = 13;
    const MONTH_FINISH_PERIOD = 7;
    const { periodStartYear } = group;

    const opt = [];
    const curDate = new Date();
    const [curMonth, curYear] = [curDate.getMonth(), curDate.getFullYear()];

    const lengthPeriod = ((curYear > periodStartYear) && curMonth > MONTH_FINISH_PERIOD) 
      ? MAX_LENGTH_PERIOD 
      : ((curYear === periodStartYear) && curMonth === 7) 
        ? 1 
        : curMonth > MONTH_FINISH_PERIOD 
          ? curMonth - (MONTH_FINISH_PERIOD - 1) 
          : curMonth + (MONTH_FINISH_PERIOD - 1);

    if (lengthPeriod < 0) {
      return ['Час роботи групи ще не настав'];
    }

    const iterCount = lengthPeriod > MAX_LENGTH_PERIOD ? MAX_LENGTH_PERIOD : lengthPeriod;

    for (let iter = iterCount; iter > 0; iter--) {
      const y_iter = iter > 5 ? periodStartYear + 1 : periodStartYear;
      const m_iter_index = iter > 5 ? iter - 6 : iter + 6;
      opt.push(`${m_iter_index + 1}.${y_iter}`);
    }

    return opt;
  }, [group]);

  // Инициализация периодов при монтировании
  useEffect(() => {
    const periods = optionsPeriodStatistic();
    setOptPeriodSt(periods);
    setPeriod(periods[0] || '');
  }, [optionsPeriodStatistic]);

  // Получение информации о детях в группе
  const getInfoMainChildrenOfGroup = useCallback(async (idGroup) => {
    if (!period) return;

    try {
      
      const response = await attendanceActions.getChildrenOfGroup(kgId, idGroup, period);
      
      if (response.data) {
        const cur_group = group;
        const ch_info = response.data.map(el => {
          if (!el._id) return el;
          if (!cur_group.hasOwnProperty('children')) return el;

          const infGr = cur_group.children.filter(grch => !grch.childId.localeCompare(el._id))[0];
          if (infGr && infGr.number) el.number = infGr.number;
          if (infGr && infGr.smallNumber) el.smallNumber = infGr.smallNumber;
          return el;
        });

        setDataListChildren(ch_info);
        
        // Обновляем infoInvites с информацией о детях
        setInfoInvites(prev => {
          const newTabel = [...prev.tabel];
          ch_info.forEach(el => {
            if (el._id && !newTabel.find(recCh => recCh.child.id === el._id)) {
              newTabel.push({
                child: {
                  firstName: el.firstName,
                  lastName: el.lastName,
                  smallNumber: el?.smallNumber || '',
                  big_number: el.number,
                  id: el._id
                },
                perdays: []
              });
            }
          });

          newTabel.sort((a, b) => {
            if (a.child.lastName > b.child.lastName) return 1;
            if (a.child.lastName < b.child.lastName) return -1;
            return 0;
          });

          return { ...prev, tabel: newTabel };
        });
      }
    } catch (err) {
      setError('Error. Get show list of children group. ' + err);
    }
  }, [kgId, period, group]);

  // Обработка данных посещаемости
  const setInfo = useCallback((data) => {
    if (!data || data.length === 0) {
      getInfoMainChildrenOfGroup(group._id);
      return;
    }

    const resp = {
      group: {
        kg_id: data[0]._id.idKg,
        gr_number: data[0]._id.grNb,
        month: data[0]._id.month
      },
      status: data[0]._id.status,
      tabel: []
    };

    data.forEach((child) => {
      let smNumb = 'недоступне';
      let bgNumber = 'недоступне';

      const arrDays = child.tabel.main.map((el, i) => {
        if (el === 1 || child.tabel.first[i] === 1) return 1;
        return -1;
      });

      if (groups && groups.length > 0) {
        groups.forEach(groupItem => {
          const fEl = groupItem.children.find(el => el.childId === child._id.idChild);
          if (fEl && fEl.smallNumber) smNumb = fEl.smallNumber;
        });
      }

      if (groups && groups.length > 0) {
        groups.forEach(groupItem => {
          const bNmb = groupItem.children.find(el => el.childId === child._id.idChild);
          if (bNmb && bNmb.number) bgNumber = bNmb.number;
        });
      }

      resp.tabel.push({
        child: {
          firstName: child.childInfo.firstName[0],
          lastName: child.childInfo.lastName[0],
          smallNumber: smNumb,
          big_number: bgNumber,
          id: child._id.idChild,
          tPl: child._id.tPl
        },
        perdays: arrDays,
        perdaysfirst: child.tabel.first
      });
    });

    setInfoInvites(resp);
    getInfoMainChildrenOfGroup(group._id);
  }, [groups, getInfoMainChildrenOfGroup, group._id]);

  // Получение временной информации
  const getInfoTemp = useCallback(async (r_data) => {
    if (!period) return;

    try {
      
      const response = await attendanceActions.getTempAttendanceInfo({kgId, kgGroup, period, isArchive});
      
      if (response.data && Array.isArray(response.data)) {
        setInfo([...r_data, ...response.data]);
      } else {
        setInfoInvites({ group: { gr_number: kgGroup }, tabel: [] });
      }
    } catch (err) {
      setError('Error getting temporary attendance info: ' + err);
    }
  }, [kgId, kgGroup, period, setInfo]);

  // Основной запрос данных
  const getInfoMain = useCallback(async () => {
    if (!period) return;

    setLoading(true);
    try {
      
      const response = await attendanceActions.getAttendanceInfo({kgId, kgGroup, period, isArchive});
      
      if (response.data && Array.isArray(response.data)) {
        await getInfoTemp(response.data);
      } else {
        setInfoInvites({ group: { gr_number: kgGroup }, tabel: [] });
      }
    } catch (err) {
      setError('Error getting attendance info: ' + err);
    } finally {
      setLoading(false);
    }
  }, [kgId, kgGroup, period, getInfoTemp]);

  // Запуск получения данных при изменении периода
  useEffect(() => {
    if (period) {
      getInfoMain();
    }
  }, [period, getInfoMain]);

  const changePeriod = (e) => {
    setPeriod(e.target.value);
  };

  const shNoneInfo = () => (
    <div className="card">
      <div className="card-body text-center">
        <h3 className="h4">
          Інформація про відвідування групи {kgGroup} за {month_ukr[parseInt(period?.split('.')[0]) - 1]} {period?.split('.')[1]}
        </h3>
        <div className="alert alert-info mt-3">
          <span>Статус: <strong>Не має інформації за обраний період</strong></span>
        </div>
      </div>
    </div>
  );

  const tableInfo = () => {
    if (!infoInvites.tabel || infoInvites.tabel.length === 0) return shNoneInfo();

  
    const nameOfFieldsPreamb = [
      { name: 'номер', key: 'comp_pos' },
      { name: 'таб.номер', key: 'smallNumber' },
      { name: 'Ім\'я', key: 'firstName' },
      { name: 'Прізвище', key: 'lastName' },
    ];

    const preamFirstLine = nameOfFieldsPreamb.map((el, index) => <th key={index}>{el.name}</th>);

    let year, month;
    if (infoInvites.group.month) {
      [month, year] = infoInvites.group.month.split('.');
    } else {
      [month, year] = period.split('.');
    }

    const getDay = (dayM) => new Date(year, month - 1, dayM + 1).getDay();

    const perdaysFirstLine = () => {
      const daysInMonth = new Date(year, month, 0).getDate();
      const arrEl = [];
      
      for (let i = 0; i < daysInMonth; i++) {
        const day = getDay(i);
        const dayName = day_ua[day].t;
        const style = day_ua[day] && day_ua[day].col ? { color: day_ua[day].col } : {};
        arrEl.push(
          <th key={i} style={style} className="text-center">
            <div>{i + 1}</div>
            <small>{dayName}</small>
          </th>
        );
      }
      return arrEl;
    };

    const sumarizeLinePerDays = () => {
      const daysInMonth = new Date(year, month, 0).getDate();
      const arrEl = [];
      
      for (let i = 0; i < daysInMonth; i++) {
        const day = getDay(i);
        const style = day_ua[day] && day_ua[day].col ? { color: day_ua[day].col } : {};
        const sumPerDay = infoInvites.tabel.reduce((sum, el) => 
          el.perdays.length > i && el.perdays[i] === 1 ? sum + 1 : sum, 0);
        arrEl.push(<td key={i} style={style} className="text-center"><strong>{sumPerDay}</strong></td>);
      }
      return arrEl;
    };

    const sumAllDays = infoInvites.tabel.reduce((sumAll, elGr) => 
      sumAll + elGr.perdays.reduce((sumRow, elRow) => elRow === 1 ? sumRow + 1 : sumRow, 0), 0);

    const preamFields = (tabel_index) => nameOfFieldsPreamb.map((el, index) => {
      if (el.key === 'comp_pos') return <td key={index}>{tabel_index + 1}</td>;
      return <td key={index}>{infoInvites.tabel?.[tabel_index]?.child?.[el.key] || ''}</td>;
    });

    const sumFields = (tabel_index) => (
      <td className="text-center"><strong>{infoInvites.tabel[tabel_index].perdays.reduce((acc, el) => el === 1 ? acc + 1 : acc, 0)}</strong></td>
    );

    const style_wobed = 'attendance-present-without-bed';
    const style_stnd = 'attendance-present';

    const perDaysPerChild = (tabel_index) => {
      const daysInMonth = new Date(year, month, 0).getDate();
      const arrEl = [];

      for (let i = 0; i < daysInMonth; i++) {
        const isPresent = infoInvites.tabel[tabel_index].perdays[i] === 1;
        const { tPl } = infoInvites.tabel[tabel_index].child;
        const info = infoInvites.tabel[tabel_index].perdays.length >= (i + 1) 
          ? infoInvites.tabel[tabel_index].perdays[i] === 1 ? 'п' : 'в' 
          : '';

        const day = getDay(i);
        let className = isPresent && tPl === 'without-bed' 
          ? style_wobed
          : isPresent 
            ? style_stnd
            : day_ua[day] && day_ua[day].col 
              ? 'attendance-weekend' 
              : 'attendance-absent';

        arrEl.push(
          <td key={i} className={`text-center ${className}`}>
            {info}
          </td>
        );
      }
      return arrEl;
    };

    const tableGroup = infoInvites.tabel.map((el, index) => (
      <tr key={index}>
        {preamFields(index)}
        {sumFields(index)}
        {perDaysPerChild(index)}
      </tr>
    ));

    return (
      <div className="card statistics-groups-container">
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <h3 className="h4 text-center mb-4">
                Інформація про відвідування групи {infoInvites.group.gr_number} за {month_ukr[parseInt(month) - 1]} {year}
              </h3>
            </div>
            <div className="col-md-12">
              <span>Статус: <strong>{status_tabel[infoInvites.status] || 'Невідомо'}</strong></span>
            </div>
            <div className="col-md-12 mt-2">
              <span>Станом на: <strong>{new Date().toLocaleDateString('uk-UK')}</strong></span>
            </div>
          </div>

          <div className="table-responsive mt-3">
            <table className="table table-striped table-bordered table-hover statistics-table statistics-table-striped statistics-table-hover">
              <thead className="statistics-table-primary">
                <tr>
                  {preamFirstLine}
                  <td style={{ verticalAlign: 'bottom' }} className="text-center"><strong>Відвідано</strong></td>
                  {perdaysFirstLine()}
                </tr>
              </thead>
              <tbody>
                {tableGroup}
              </tbody>
              <tfoot className="table-footer">
                <tr>
                  {nameOfFieldsPreamb.map((_, index) => <td key={index}></td>)}
                  <td className="text-center"><strong>{sumAllDays}</strong></td>
                  {sumarizeLinePerDays()}
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="attendance-legend">
            <span>Кольорами позначені типи місць:</span>
            <div className="legend-item">
              <span className="legend-color legend-short-term"></span>
              <span>короткотривале</span>
            </div>
            <div className="legend-item">
              <span className="legend-color legend-full-day"></span>
              <span>повного дня</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Помилка: {error}
      </div>
    );
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Завантаження...</span>
        </div>
        <span className="ms-2">Завантаження...</span>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="row mb-4">
            <div className="col-md-6 col-lg-4">
              <label htmlFor="periodSelect" className="form-label">Оберіть період:</label>
              <select 
                id="periodSelect"
                className="form-select" 
                onChange={changePeriod} 
                value={period}
              >
                {optPeriodSt.map((el, index) => (
                  <option key={index} value={el}>
                    {`${month_ukr[+el.split('.')[0] - 1]} ${el.split('.')[1]}`}
                  </option>
                ))}
              </select>
            </div>
          </div>
          
          {infoInvites?.tabel?.length > 0 ? tableInfo() : shNoneInfo()}
        </div>
      </div>
    </div>
  );
};

export default StatisticaAttendanceGroup;